"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ETwoFactorType = void 0;
let ETwoFactorType = exports.ETwoFactorType = /*#__PURE__*/function (ETwoFactorType) {
  ETwoFactorType["Phone"] = "phone";
  ETwoFactorType["Email"] = "email";
  return ETwoFactorType;
}({});